import { call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import tagsService from './tagsService'
import {
  createTagSuccess,
  deleteTagSuccess,
  getTagsSuccess,
  tagsActions,
  updateTagEmployeesSuccess,
  updateTagSuccess,
} from './tagsSlice'

export function* getTagsSaga() {
  try {
    const response = yield call(tagsService.getTags)
    yield put(getTagsSuccess(response.data))
  } catch (error) {
    // handled by global error handler
  }
}

export function* createTagSaga(action: ReturnType<typeof tagsActions.createTag>) {
  try {
    const response = yield call(tagsService.createTag, action.payload)
    yield put(createTagSuccess(response.data))
  } catch (error) {
    // handled by global error handler
  }
}

export function* updateTagSaga(action: ReturnType<typeof tagsActions.updateTag>) {
  try {
    const response = yield call(tagsService.updateTag, action.payload)
    yield put(updateTagSuccess(response.data))
  } catch (error) {
    // handled by global error handler
  }
}

export function* deleteTagSaga(action: ReturnType<typeof tagsActions.deleteTag>) {
  try {
    yield call(tagsService.deleteTag, action.payload)
    yield put(deleteTagSuccess(action.payload))
  } catch (error) {
    // handled by global error handler
  }
}

export function* addTagEmployeesSaga(
  action: ReturnType<typeof tagsActions.addTagEmployees>
) {
  try {
    const response = yield call(tagsService.addTagEmployees, action.payload)
    yield put(updateTagEmployeesSuccess(response.data))
  } catch (error) {
    // handled by global error handler
  }
}

export function* removeTagEmployeesSaga(
  action: ReturnType<typeof tagsActions.removeTagEmployees>
) {
  try {
    const response = yield call(tagsService.removeTagEmployees, action.payload)
    yield put(updateTagEmployeesSuccess(response.data))
  } catch (error) {
    // handled by global error handler
  }
}

export default function* tagsSaga() {
  yield takeLatest(tagsActions.getTags.type, getTagsSaga)
  yield takeLatest(tagsActions.createTag.type, createTagSaga)
  yield takeLatest(tagsActions.updateTag.type, updateTagSaga)
  yield takeLatest(tagsActions.deleteTag.type, deleteTagSaga)
  yield takeEvery(tagsActions.addTagEmployees.type, addTagEmployeesSaga)
  yield takeEvery(tagsActions.removeTagEmployees.type, removeTagEmployeesSaga)
}
